"use client";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { AddMemberRequest } from "@chotca/config";
import { getSdk } from "../sdk";
import { qk } from "../query-keys";

export function useMembers(orgId: string | null | undefined) {
  return useQuery({
    queryKey: qk.orgs.members(orgId ?? ""),
    queryFn: async () => getSdk().members.list(orgId!),
    enabled: !!orgId,
    staleTime: 15_000,
  });
}

export function useAddMember(orgId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: AddMemberRequest) =>
      getSdk().members.add(orgId, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.orgs.members(orgId) });
    },
  });
}

export function useRemoveMember(orgId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (membershipId: string) =>
      getSdk().members.remove(orgId, membershipId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.orgs.members(orgId) });
    },
  });
}
